import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

import subtitle from '../../../../assets/images/reg-guide/subtitle.png';

export const useStyles = makeStyles(({
  fontWeights, fontSizes, lineHeights, breakpoints, siteMaxWidth, palette,
}: Theme) => ({
  root: {
    paddingTop: '1.75rem',
    [breakpoints.up('md')]: {
      width: '100%',
      maxWidth: siteMaxWidth,
      margin: '0 auto',
    },
  },
  bannerReg: {
    margin: 0,
    background: `linear-gradient(180deg, ${palette.primary.dark} 0%, ${palette.primary.main} 93.39%)`,
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'flex-end',
    scrollMarginTop: '4.5rem',
    [breakpoints.up('md')]: {
      justifyContent: 'center',
    },
  },
  strong: {
    fontWeight: fontWeights.medium,
  },
  paragraph: {
    marginTop: 0,
    marginBottom: 16,
    paddingLeft: '2rem',
    paddingRight: '2rem',
    fontSize: fontSizes.sm,
    lineHeight: lineHeights.md,
    '&:last-of-type': {
      marginBottom: '1.75rem',
    },
  },
  subtitle: {
    width: '100%',
    maxWidth: '48rem',
    height: 280,
    margin: '0 auto 1.75rem',
    padding: '1.25rem 0 0 0.675rem',
    background: `#cbe880 no-repeat url(${subtitle}) bottom right`,
    backgroundSize: '50% auto',
    color: palette.info.dark,
    fontSize: fontSizes.lg,
    lineHeight: 1.5,
    fontWeight: fontWeights.medium,
    scrollMarginTop: '4.5rem',
  },
  block: {
    display: 'block',
  },
  center: {
    textAlign: 'center',
  },
}));
